import { append, curry, pipe, without } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const addItem = curry((item, list) => pipe(
  without([item]),
  append(item)
)(list));



// WEBPACK FOOTER //
// ./src/app/utils/functional.js